import type { RouteLocationNormalizedLoaded } from 'vue-router';

type RouteViewKeyInput = Pick<RouteLocationNormalizedLoaded, 'fullPath' | 'meta' | 'path'>;

/**
 * Filter lists keep their component instance while synchronising filters to
 * the query string. Other routes retain the existing full-path identity so a
 * query-only navigation can still remount pages that depend on mount-time
 * query handling.
 */
export function getRouteViewKey(route: RouteViewKeyInput): string {
    return route.meta.preserveViewOnQueryChange === true ? route.path : route.fullPath;
}
